<template>
  <modal name="modal-share" class="modal-dialog" :draggable="true" :resizable="true">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-label">結果をシェアする</h4>
      </div>
      <div class="modal-body">
        <p>コピペして利用してね！</p>
        <textarea style="width:100%;">【減災力テスト】あなたの結果は、「{{ $props.remark }}」でした。紹介コードは{{ $props.id }}。http://gensaikyoushitsu.sakura.ne.jp/</textarea>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="$modal.hide('modal-share')">
          閉じる
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: [
    'id',
    'remark', 
  ],
}
</script>